import { z } from 'zod';

export const CampaignPlacement = z.enum([
  'TYP_EHEALTH_U65_CLICK',
  'TYP_ELITEINSURANCE',
  'TYP_SVG',
  'TYP_TRANZACT',
  'TYP_AARP_CLICK',
  'TYP_CONNECTME',
  'TYP_CALL_MOBILE',
  'TYP_CALL_DESKTOP',
  'TYP_HCI',
  'TYP',
  'TYP_FOOTER',
  'LANDING',
  'SURVEY',
  'EMAIL',
  'BTYP_FIRSTFAMILY',
  'BTYP_ALLIEDHEALTH',
  'BTYP_EHEALTH',
  'BTYP_MLBENEFITS',
  'BTYP_BENEFITSBOSS',
  'BTYP_GREENVINE',
  'BTYP_ASSUREDHEALTH',
  'BTYP_MEDICAREQUOTES',
  'BTYP_FORTEGRA',
  'BTYP_USHAMONTAGUE',
  'BTYP_USHAKONCURAT',
  'BTYP_IHEALTHQUOTES',
  'BTYP_MEDICAREGENIUS',
  'BTYP_HMSOLUTIONS',
  'BTYP_SELFGOOD',
  'BTYP_ROCKETHEALTH',
  'MS_QUOTES_PLANCARD',
  'MS_QUOTES_AGENTCARD',
  'MS_QUOTEINFO_TAB',
  'TYP_STICKY_BANNER',
  'UCC_V1_CONNECTME',
  'UCC_V1_CLICKTOCALL',
  'UCC_CONTROL_CLICKTOCALL',
  'UCC_CONTROL_CONNECTME',
  'TYP_QUOTES_NO_PHONE',
]);

export type CampaignPlacement = z.infer<typeof CampaignPlacement>;
